import PropTypes from "prop-types";
import WebIcon from "@/components/common/Web_Icons";

const EmptyState = ({ ...props }) => {
  return (
    <div className="empty-state-container" {...props}>
      <div
        className="flex flex-col items-center justify-center rounded-lg p-8 mt-6 max-w-[600px] mx-auto"
        data-testid="canvass-empty-state">
        <WebIcon
          icon="CanvassHover"
          size="large"
          className="mb-6 w-[100px] h-[100px]"
        />
        <h2 className="heading-large whitespace-nowrap font-bold text-lighterGrey mb-4">
          Canvass Empty
        </h2>
        <p className="text-bold-x font-normal text-lighterGrey mb-8">
          There&apos;s nothing to show here
        </p>
      </div>
    </div>
  );
};

EmptyState.propTypes = {
  onSetup: PropTypes.func,
};

export default EmptyState;
